export default function ChartIcon({ ...props }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="currentColor" {...props}>
            <path d="M6.75 39.25h10.5v-18.5H6.75Zm12 0h10.5V8.75h-10.5Zm12 0h10.5v-14.5h-10.5Zm-25.5 1.5v-21.5h12v-12h13.5v16h12v17.5Z" />
		</svg>
	)
}